import { Injectable, Injector } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpDataService } from 'core/services/http-data.service';

@Injectable()
export class GroupDashboardService extends HttpDataService {
  public dataSubject = new BehaviorSubject(null);
  public data: any;

  constructor(protected injector: Injector) {
    super(injector, '/dashboard');
  }

  getMetadata(): Observable<any> {
    return this.http.get(`${this.baseUrl}/metadata`, this.getRequestOptions(null));
  }

  getActivity(options?: Object): Observable<any> {
    const url = `${this.baseUrl}/licenses/activity`;
    return this.http.get(url, this.getRequestOptions(options));
  }

  getMostActiveStudents(options?: Object): Observable<any> {
    const url = `${this.baseUrl}/licenses/most-active`;
    return this.http.get(url, this.getRequestOptions(options));
  }

  getLastFinishedStudents(options?: Object): Observable<any> {
    const url = `${this.baseUrl}/licenses/last-finished`;
    return this.http.get(url, this.getRequestOptions(options));
  }
}
